import { takeLatest, call, put } from 'redux-saga/effects';
import { getUrgencyStatements } from 'yoda-interfaces/lib/Pdp/UrgencyMessagingApi';
import {
    URGENCY_MESSAGE_GET_SUCCESS,
    URGENCY_MESSAGE_GET_REQUEST,
} from '../actionTypes/UrgencyMessagingActionTypes';

function* UrgencyMessagingSaga(action) {
    try {
        const urgencyStatements = yield call(
            getUrgencyStatements,
            action.payload.ppid,
            action.payload.apiURL
        );
        yield put({ type: URGENCY_MESSAGE_GET_SUCCESS, urgencyStatements });
    } catch (error) {
        yield put({ type: 'CONTENT_ERROR', error });
    }
}

const watchUrgencyMessagingSaga = function* watchUrgencyMessagingSaga() {
    yield takeLatest(URGENCY_MESSAGE_GET_REQUEST, UrgencyMessagingSaga);
};

watchUrgencyMessagingSaga.sagaName = 'urgencyMessagingSaga';
export default watchUrgencyMessagingSaga;
